// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"2308a98f","55":"a78edb81","170":"c08a8cf2","711":"bacbf8d6"}[chunkId] + ".chunk.js";
};